// store/index.js
import { get, unionBy } from 'lodash';
import {mergeDeviceArray, getAttrValue, getTotalChannel} from '@/utils/helper'
import { CHANNEL_GROUP } from '@/utils/const'

const initState = {
  mppt: [],
  bms: [],
  inv: [],
  dcdc: [],
  system: [],
  gas: [],
  alarmList: [],
  watertank: [],
  thermosta: [],
  rooffan: [],
  channel: [],
  channels: {
      channels: [],
      equipmentChannels: [],
      lightChannels: [],
      slideGroupList: [],
      awningGroupList: [],
      headerChannels: [],
      essentialLoadChannels: [],
      genChannels: [],
      mainChannels: []
    },
    tpms: [],
    gy485: []
}

const essentialLoadDeviceIds = [9, 10, 11, 2]


const store = {
  state: {
    vehicleId: undefined,
    pcuCount: 0,
    mppt: [],
    bms: [],
    inv: [],
    dcdc: [],
    system: [],
    gas: [],
    alarmList: [],
    watertank: [],
    thermosta: [],
    rooffan: [],
    deviceList: [],
    channels: {
      channels: [],
      equipmentChannels: [],
      lightChannels: [],
      slideGroupList: [],
      awningGroupList: [],
      headerChannels: [],
      essentialLoadChannels: [],
      genChannels: [],
       mainChannels:[]
    },
    tpms: [],
    gy485: []
  },
  mutations: {
    setBatteryData(state,{ bms, mppt, inv, dcdc, system, gas, watertank, thermosta, rooffan, tpms, gy485}) {

      if(tpms) {
        if(!state.tpms.length) {
          state.tpms = tpms
        } else {
          state.tpms = mergeDeviceArray({newDeviceArray: tpms, oldDeviceArray: state.tpms})
        }
      }

      if(gy485) {
        if(!state.gy485.length) {
          state.gy485 = gy485
        } else {
          state.gy485 = mergeDeviceArray({newDeviceArray: gy485, oldDeviceArray: state.gy485})
        }
      }

      if(thermosta) {
        if(!state.thermosta.length) {
          state.thermosta = thermosta
        } else {
          state.thermosta = mergeDeviceArray({newDeviceArray: thermosta, oldDeviceArray: state.thermosta})
        }
      }

      if(rooffan) {
        if(!state.rooffan.length) {
          state.rooffan = rooffan
        } else {
          state.rooffan = mergeDeviceArray({newDeviceArray: rooffan, oldDeviceArray: state.rooffan})
        }
      }

      if(bms) {
        if(!state.bms.length) {
          state.bms = bms
        } else {
          state.bms = mergeDeviceArray({newDeviceArray: bms, oldDeviceArray: state.bms})
        }
      }

      if(mppt) {
        if(!state.mppt.length) {
          state.mppt = mppt
        } else {
          state.mppt = mergeDeviceArray({newDeviceArray: mppt, oldDeviceArray: state.mppt})
        }
      }

      if(inv) {
        if(!state.inv.length) {
          state.inv = inv
        } else {
          state.inv = mergeDeviceArray({newDeviceArray: inv, oldDeviceArray: state.inv})
        }
      }

      if(dcdc) {
        if(!state.dcdc.length) {
          state.dcdc = dcdc
        } else {
          state.dcdc = mergeDeviceArray({newDeviceArray: dcdc, oldDeviceArray: state.dcdc})
        }
      }

      if(system) {
        if(!state.system.length) {
          state.system = system
        } else {
          state.system = mergeDeviceArray({newDeviceArray: system, oldDeviceArray: state.system})
        }
        // showInverterDialog(state.system, state.alarmList)
        state.pcuCount = Number(getAttrValue(system, '0.realMap.pcu_count.0.data.value', 0))
      }

      if(gas) {
        if(!state.gas.length) {
          state.gas = gas
        } else {
          state.gas = mergeDeviceArray({newDeviceArray: gas, oldDeviceArray: state.gas})
        }
      }

      if(watertank) {
        if(!state.watertank.length) {
          state.watertank = watertank
        } else {
          state.watertank = mergeDeviceArray({newDeviceArray: watertank, oldDeviceArray: state.watertank})
        }
      }
       
    },
    setDeviceList(state, { deviceList }) {
      state.deviceList = deviceList
    },
    setAlarmList(state, { alarmList }) {
      state.alarmList = alarmList
      // showInverterDialog(state.system, state.alarmList)
    },
    setVehicleId(state, { vehicleId }) {
      state.vehicleId = vehicleId
      state.bms = []
      state.mppt = []
      state.inv = []
      state.dcdc = []
      state.system = []
      state.gas = []
      state.watertank = []
      state.watertank = []
      state.thermosta = []
      state.rooffan = []
      state.channels = {
        channels: [],
        equipmentChannels: [],
        lightChannels: [],
        slideGroupList: [],
        awningGroupList: [],
        headerChannels: [],
        essentialLoadChannels: [],
        genChannels: []
      },
      state.tpms = []
      state.gy485 = []
    },
    setChancel(state, {channels, mainChannels, equipmentChannels, lightChannels, awningGroupList, slideGroupList, headerChannels, essentialLoadChannels,  genChannels}) {
      state.channels = {channels, mainChannels, equipmentChannels, lightChannels, awningGroupList, slideGroupList, headerChannels, essentialLoadChannels, genChannels}
    }
  },
  actions: {
    fetchBatteryData({ commit }, message) {
      const { data } = message;
      if(data && typeof data === 'object') {
         const { bms, mppt, inv, dcdc, system, gas, watertank, thermosta, rooffan, channel, tpms, gy485 } = data
         commit('setBatteryData', {bms, mppt, inv, dcdc, system, gas, watertank, thermosta, rooffan, channel, tpms, gy485})
      }
    },
    fetchAlarmList({ commit}, message) {
      const { data } = message;
      if(data && typeof data === 'object') {
        const { alarmList } = data;
        commit('setAlarmList', { alarmList })
      }
    },
    fetchChannelData({commit}, message) {
       const channelGroup = getTotalChannel(get(message, 'data.channel', []))
       let lightDeviceIds = [];
       let equipmentDeviceIds = []
       let headerDeviceIds = []
       let mainDeviceIds = []
       let newChannels = []
       let channels = []
       let originChannels = this.state.realTimeData.channels.channels
       let lightRefresh;
       let equipmentRefresh;
       let headerRefresh;
       let mainRefresh;
       let awningGroupList = this.state.realTimeData.channels.awningGroupList
       let slideGroupList = this.state.realTimeData.channels.slideGroupList
       let genChannels = this.state.realTimeData.channels.genChannels
       let newGenChannels = []
       
       channelGroup.forEach(group => {
          newChannels = [...newChannels, ...group.simpleList]
          if (group.moduleId === CHANNEL_GROUP.SLIDE) {
            const refresh =  group.refresh;
            if(refresh) {
              slideGroupList = group.groupList
            }
          
          }
          if (group.moduleId === CHANNEL_GROUP.AWNING) {
            const refresh =  group.refresh;
            if(refresh) {
              awningGroupList = group.groupList
            }
            
          }
          if(group.moduleId === CHANNEL_GROUP.LIGHT) {
            lightRefresh = group.refresh;
            lightDeviceIds = !lightRefresh ?  this.state.realTimeData.channels.lightChannels.map(c => c.deviceId) : group.simpleList.map(item => item.deviceId); 
          }
          if(group.moduleId === CHANNEL_GROUP.EQUIPMENT) {
            equipmentRefresh = group.refresh
            equipmentDeviceIds = !equipmentRefresh ? this.state.realTimeData.channels.equipmentChannels.map(c => c.deviceId) : group.simpleList.map(item => item.deviceId)
            
          }
           if(group.moduleId === CHANNEL_GROUP.MAIN) {
            mainRefresh = group.refresh
            mainDeviceIds = !mainRefresh ? this.state.realTimeData.channels.mainChannels.map(c => c.deviceId) : group.simpleList.map(item => item.deviceId)
          }
          if(group.moduleId === CHANNEL_GROUP.GEN) {
            const genRefresh = group.refresh;
            const {groupList} = group
            groupList.forEach(g => {
              newGenChannels = [...newGenChannels, ...g.simpleList]
            })
            if(genRefresh) {
              genChannels = newGenChannels
            } else {
              genChannels = genChannels.map(channel => {
                 const currentChannel = newGenChannels.find(nC => nC.deviceId === channel.deviceId)

                 if(currentChannel) return currentChannel

                 return channel

              })
            }
          }
          if(group.moduleId === CHANNEL_GROUP.MAIN_HEAD) {
             headerRefresh = group.refresh
             headerDeviceIds = !headerRefresh ? this.state.realTimeData.channels.headerChannels.map(c => c.deviceId) : group.simpleList.map(item => item.deviceId)
          }
       })
       channels = unionBy(newChannels, originChannels, 'deviceId')
       console.log(lightDeviceIds, 'lightDeviceIds')
       let lightChannels = lightRefresh ? channels.filter(c => lightDeviceIds.includes(c.deviceId)) : unionBy(channels.filter(c => lightDeviceIds.includes(c.deviceId)), this.state.realTimeData.channels.lightChannels, 'deviceId').sort((a, b) => lightDeviceIds.indexOf(a.deviceId) - lightDeviceIds.indexOf(b.deviceId))
       let equipmentChannels = equipmentRefresh ? channels.filter(c => equipmentDeviceIds.includes(c.deviceId)).sort((a, b) => a.deviceId - b.deviceId) : unionBy(channels.filter(c => equipmentDeviceIds.includes(c.deviceId)).sort((a, b) => a.deviceId - b.deviceId), this.state.realTimeData.channels.equipmentChannels,'deviceId').sort((a, b) => a.deviceId - b.deviceId)
       let headerChannels = headerRefresh ? channels.filter(c => headerDeviceIds.includes(c.deviceId)).sort((a, b) => a.deviceId - b.deviceId) : unionBy(channels.filter(c => headerDeviceIds.includes(c.deviceId)).sort((a, b) => a.deviceId - b.deviceId), this.state.realTimeData.channels.headerChannels, 'deviceId').sort((a, b) => a.deviceId - b.deviceId)
       let mainChannels = mainRefresh ? channels.filter(c => mainDeviceIds.includes(c.deviceId)).sort((a, b) => a.deviceId - b.deviceId) : unionBy(channels.filter(c => mainDeviceIds.includes(c.deviceId)).sort((a, b) => a.deviceId - b.deviceId), this.state.realTimeData.channels.mainChannels, 'deviceId').sort((a, b) => a.deviceId - b.deviceId)
       
       let essentialLoadChannels = essentialLoadDeviceIds.map(id => {
          const currentChannel  = channels.find(channel => channel.deviceId === id)

          return currentChannel
       }).filter(item => item)
       console.log(genChannels, 'genChannels')
       commit('setChancel', {equipmentChannels, mainChannels, lightChannels, channels, awningGroupList, slideGroupList, headerChannels, essentialLoadChannels, genChannels:  genChannels.sort((a, b) => a.deviceId - b.deviceId) })
    }
  }
}

export default store